import { Injectable } from '@angular/core';
import { CredentialsService } from '../credentials.service';
import { BehaviorSubject } from 'rxjs';
import { Credentials } from 'src/app/_model/credentials';
import { LoggingService } from 'src/app/_services/logging/logic/logging.service';
import { AuthenticationService } from 'src/app/_services/authentication/authentication.service';
import { CredentialsDaoService } from '../../dao/credentials-dao.service';
import { InitializeStatus } from 'src/app/_services/initialize/initialize-aware';

@Injectable()
export class CredentialsLogicService implements CredentialsService {
  public credentials$ = new BehaviorSubject<Credentials>(undefined);
  public initializeStatus$: BehaviorSubject<InitializeStatus> = new BehaviorSubject(InitializeStatus.NOT_INITIALIZED);

  constructor(
    private logger: LoggingService,
    private credentialsDaoService: CredentialsDaoService,
    private authenticationService: AuthenticationService
  ) {
    this.initialize()
    this.authenticationService.authenticationState.subscribe({
      next: authenticated => {
        if (authenticated) {
          const credentials = new Credentials();
          credentials.username = this.authenticationService.getUserName();
          this.logger.log(
            this.constructor.name,
            '- received new credentials',
            credentials
          );
          this.credentials$.next(credentials);
          this.credentialsDaoService.saveCredentials(credentials);
          this.logger.log(this.constructor.name, '- saved new credentials');
        }
      }
    });
  }
  async initializeCompleted(): Promise<void> {

  }

  // InitializeAware
  async initialize(): Promise<void> {
    this.initializeStatus$.next(InitializeStatus.INITIALIZING)
    try {
      await this.loadLocalCredentials();
      this.initializeStatus$.next(InitializeStatus.INITIALIZED)
    } catch (error) {
      this.logger.error(
        this.constructor.name,
        'Error loading local data: ',
        error?.message
      );
      this.initializeStatus$.next(InitializeStatus.FAILED_INITIALIZE)
    }
  }

  public async reset() {
    this.logger.log(this.constructor.name, '- Credentials are not resetable');
  }
  public async clear() {
    this.logger.log(this.constructor.name, '- clearing credentials');
    await this.credentialsDaoService.clear();
    this.credentials$.next(undefined);
  }

  // Private Functions
  private async loadLocalCredentials() {
    try {
      this.logger.log(this.constructor.name, '- Load local credentials');
      const credentials = await this.credentialsDaoService.getCredentials()
      this.credentials$.next(credentials);
    } catch (error) {
      this.logger.error(
        this.constructor.name,
        'Error loading local credentials: ',
        error?.message
      );
      throw error;
    }
  }
}
